import type { RouteRecordRaw } from 'vue-router'

export const supplierRoutes: RouteRecordRaw[] = [
  {
    path: '/suppliers',
    name: 'suppliers',
    component: () => import('@/modules/supplier/views/SuppliersView.vue'),
    meta: {
      title: 'Наши поставщики',
      requiresFeature: 'supplier_showcase_enabled',
    },
  },
  {
    path: '/suppliers/register',
    name: 'supplier-registration',
    component: () => import('@/modules/supplier/views/SupplierRegistrationView.vue'),
    meta: {
      title: 'Регистрация поставщика',
      description:
        'Подключите компанию к ЛабАктив и публикуйте каталог оборудования, материалов и расходников для B2B-заказчиков.',
    },
  },
  {
    path: '/supplier/register',
    name: 'supplier-register',
    component: () => import('@/modules/supplier/views/SupplierRegisterView.vue'),
    meta: {
      title: 'Регистрация поставщика',
      requiresSupplierGuest: true,
    },
  },
  {
    path: '/supplier-invitation',
    name: 'supplier-invitation',
    component: () => import('@/modules/supplier/views/SupplierInvitationView.vue'),
    meta: {
      title: 'Приглашение в команду поставщика',
    },
  },
  {
    path: '/supplier',
    name: 'supplier',
    redirect: '/supplier/dashboard',
    meta: { requiresSupplierAuth: true },
  },
  {
    path: '/supplier/dashboard',
    name: 'supplier-dashboard',
    component: () => import('@/modules/supplier/views/SupplierDashboardView.vue'),
    meta: {
      title: 'Дашборд поставщика',
      requiresSupplierAuth: true,
    },
  },
  {
    path: '/supplier/products',
    name: 'supplier-products',
    component: () => import('@/modules/supplier/views/SupplierProducts.vue'),
    meta: {
      title: 'Товары поставщика',
      requiresSupplierAuth: true,
    },
  },
  {
    path: '/supplier/import-guide',
    name: 'supplier-import-guide',
    component: () => import('@/modules/supplier/views/SupplierImportGuide.vue'),
    meta: {
      title: 'Импорт товаров',
      requiresSupplierAuth: true,
    },
  },
  {
    path: '/supplier/orders',
    name: 'supplier-orders',
    component: () => import('@/modules/supplier/views/SupplierOrders.vue'),
    meta: {
      title: 'Заказы поставщика',
      requiresSupplierAuth: true,
    },
  },
  {
    path: '/supplier/profile',
    name: 'supplier-profile',
    component: () => import('@/modules/supplier/views/SupplierProfile.vue'),
    meta: {
      title: 'Профиль поставщика',
      requiresSupplierAuth: true,
    },
  },
  {
    path: '/supplier/addresses',
    name: 'supplier-addresses',
    component: () => import('@/modules/supplier/views/SupplierAddresses.vue'),
    meta: {
      title: 'Склады и точки отгрузки',
      requiresSupplierAuth: true,
    },
  },
  {
    path: '/supplier/documents',
    name: 'supplier-documents',
    component: () => import('@/modules/supplier/views/SupplierDocuments.vue'),
    meta: {
      title: 'Документы поставщика',
      requiresSupplierAuth: true,
    },
  },
]
